export default "__VITE_ASSET__Db1Vh0js__"